<script setup>
import { getTagDatasource } from '@/data/tag';
import { ROUTE_TAGS } from '@/router/routeNames';
import { DxButton } from 'devextreme-vue/button';
import { DxColumn, DxDataGrid, DxPaging, DxScrolling, DxToolbar } from 'devextreme-vue/data-grid';
import { DxItem } from 'devextreme-vue/toolbar';
import { useRouter } from 'vue-router';

const router = useRouter();

const tagDatasource = getTagDatasource();
tagDatasource.sort([{ selector: 'navn', desc: false }]);

function onRowClick(e) {
  const tagId = e.data.id;
  router.push(`${ROUTE_TAGS}/${tagId}`);
}

function opretTag() {
  router.push(`${ROUTE_TAGS}/-1`);
}
</script>

<template>
  <DxDataGrid
    :data-source="tagDatasource"
    :remote-operations="true"
    :row-alternation-enabled="true"
    :show-column-lines="false"
    :hover-state-enabled="true"
    :show-borders="true"
    @row-click="onRowClick"
    height="100%"
  >
    <DxScrolling mode="virtual" row-rendering-mode="virtual" :preload-enabled="true" />
    <DxPaging :page-size="50" />

    <DxToolbar>
      <DxItem location="before">
        <DxButton
          text="Opret tag"
          icon="plus"
          @click="opretTag"
          type="default"
          styling-mode="text"
        />
      </DxItem>
    </DxToolbar>

    <DxColumn data-field="navn" />
  </DxDataGrid>
</template>

<style></style>
